import { Grid } from '@mantine/core';
import type { PropsWithChildren } from 'react';

import { ActionableTicker } from './tickers/ActionableTicker';
import { AtRiskTicker } from './tickers/AtRiskTicker';
import { DisputedTicker } from './tickers/DisputedTicker';
import { PausedTicker } from './tickers/PausedTicker';
import { TotalReceivableTicker } from './tickers/TotalReceivableTicker';

const TICKER_COUNT = 5;

const TickerColumn = ({ children }: PropsWithChildren) => (
  <Grid.Col span={{ base: TICKER_COUNT, md: 1 }}>{children}</Grid.Col>
);

export const TickersBanner = () => (
  <Grid my="lg" mt="md" columns={TICKER_COUNT}>
    <TickerColumn>
      <TotalReceivableTicker />
    </TickerColumn>
    <TickerColumn>
      <AtRiskTicker />
    </TickerColumn>
    <TickerColumn>
      <DisputedTicker />
    </TickerColumn>
    <TickerColumn>
      <PausedTicker />
    </TickerColumn>
    <TickerColumn>
      <ActionableTicker />
    </TickerColumn>
  </Grid>
);
